import { Controller } from '@hotwired/stimulus';
import Floatl from '../components/floating-label';

export default class extends Controller {
  connect() {
    this.setup();
  }

  setup() {
    const labelWrappers = this.element.querySelectorAll(
        '.form-field, .newsletter-form'
    );
    this.labels = [];

    if (labelWrappers.length) {
      labelWrappers.forEach((label, i) => {
        this.labels[i] = new Floatl(label);
      });
    }
  }
}
